(() => {
  let current = null;
  let returnTo = null;
  let restore = [];
  const focusable = root => [...root.querySelectorAll('a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]')].filter(el => !el.closest('[hidden], [inert]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  const restorePage = () => { restore.forEach(([el, value]) => { el.inert = value; }); restore = []; };
  const update = () => {
    const cart = document.querySelector('[data-c11-cart-drawer]:not([hidden])');
    const search = document.querySelector('[data-c11-panel="search"]:not([hidden])');
    const drawer = document.querySelector('[data-c11-drawer].is-open');
    const next = cart || search || drawer;
    if (next === current) return;
    restorePage();
    const previous = current;
    current = next;
    if (!next) { document.body.style.overflow = ''; if (returnTo?.isConnected && !returnTo.closest('[hidden], [inert]')) returnTo.focus(); returnTo = null; return; }
    if (!previous) returnTo = document.activeElement;
    const nestedDialog = next.querySelector('[role=dialog]');
    if (nestedDialog) { nestedDialog.removeAttribute('role'); nestedDialog.removeAttribute('aria-modal'); }
    next.setAttribute('role', 'dialog'); next.setAttribute('aria-modal', 'true'); next.setAttribute('tabindex', '-1');
    if (!next.hasAttribute('aria-label')) next.setAttribute('aria-label', next === cart ? 'Cart' : next === search ? 'Search' : 'Menu');
    for (let node = next; node && node !== document.body; node = node.parentElement) {
      [...node.parentElement.children].forEach(sibling => { if (sibling !== node && !['SCRIPT','STYLE','LINK'].includes(sibling.tagName)) { restore.push([sibling,sibling.inert]); sibling.inert = true; } });
    }
    document.body.style.overflow = 'hidden';
    const target = next === search ? next.querySelector('input[type="search"]') : focusable(next)[0];
    (target || next).focus();
  };
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || !current) return;
    const options = focusable(current);
    if (!options.length) { event.preventDefault(); current.focus(); return; }
    const first = options[0], last = options[options.length - 1];
    if (event.shiftKey && (document.activeElement === first || !current.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !current.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });
  new MutationObserver(update).observe(document.body, {subtree:true,attributes:true,attributeFilter:['hidden','class','aria-hidden']});
  update();
})();
